import { render } from "./ReportDisplayField.vue?vue&type=template&id=09a99578&scoped=true"
import script from "./ReportDisplayField.vue?vue&type=script&lang=js"
export * from "./ReportDisplayField.vue?vue&type=script&lang=js"

import "./ReportDisplayField.vue?vue&type=style&index=0&id=09a99578&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a99578"]])

export default __exports__